<hmd-list-page>
  <template #header>
    <flow-status-tab
      ref="flowTabRef"
      v-model:flowStatus="status"
      :bizCode="bizType"
      v-if="!isIframe"
    ></flow-status-tab>
    <list-query-header
      v-model:formModel="queryRef"
      :search="search"
      :loading="loading"
      :labelWidth="110"
      @setTableHeight="setTableHeight"
      @reset="reset"
      v-if="!isIframe"
    >
      <template #form="{appendToParent}">
        <slot name="query" :appendToParent="appendToParent"> </slot>
      </template>
    </list-query-header>
  </template>
  <template #body>
    <table-wrapper
      :dataSource="dataSource"
      @onTableChange="onTableChange"
      @onSelectionChange="onSelectionChange"
      :pagination="pagination"
      :tableHeight="tableHeight"
      :loading="loading"
      :columns="tableColumn"
      :key="childKey"
      :flowStatus="status"
      :showCustomSetting="showCustomSetting"
      ref="tableRef"
      @lastTimeEvent="lastTimeEvent"
      :timeSort="true"
      :bizType="bizType"
    >
      <template #buttons>
        <a-space>
          <slot v-if="!isDeletedStatus" name="tableButtons"></slot>
          <!-- <recycle-bin-btn
            v-if="isDeletedStatus"
            :selectedIds="selectedIds"
            :queryRef="queryRef"
            :recycleBinConfig="recycleBinConfig"
            @refresh="search"
          ></recycle-bin-btn> -->
          <export-btn
            v-if="exportConfig"
            v-perm="exportConfig.premKey"
            :api="exportConfig.api"
            :selectedIds="selectedIds"
            :queryRef="queryRef"
            :tableColumn="exportColumn"
            :isRecycled="isDeletedStatus"
          ></export-btn>
          <span v-if="filterTotalAmount" style="color: red"
            >当前条件下总金额：{{filterTotalAmount}}元</span
          >
          <span v-if="bizType == 'settlement_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'receipt_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'payment_order_external_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'margin_payment_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'margin_return_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'expense_account_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'make_invoice_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
          <span v-if="bizType == 'income_invoice_examine'" style="color: red">选中总金额：{{allTotalMoney}}元</span>
        </a-space>
      </template>
      <template v-for="(index, name) in tableSlot" v-slot:[name]="data">
        <slot :name="name" :record=" data?data.record:{}"></slot>
      </template>
      <template #flowStatusName="{ record } ">
        <span v-if="record.flowStatus=='dtj'" style="color: #fec25a"
          >{{ record.flowStatusName }}</span
        >
        <span v-else-if="record.flowStatus=='spz'" class="theme-color" style="color: #2f7bff"
          >{{ record.flowStatusName }}</span
        >
        <span v-else-if="record.flowStatus=='sptg'" style="color: #94c730"
          >{{ record.flowStatusName }}</span
        >
        <span v-else-if="record.flowStatus=='spbtg'" style="color: #969696"
          >{{ record.flowStatusName }}</span
        >
        <span v-else-if="record.flowStatus=='ycx'" style="color: #969696"
          >{{ record.flowStatusName }}</span
        >
        <span v-else-if="record.flowStatus=='yzf'" style="color: #969696"
          >{{ record.flowStatusName }}</span
        >
        <span v-else>{{ record.flowStatusName }}</span>
      </template>

      <template #operation="{record}">
        <table-flow-btn-new
          :record="record"
          :operationExternalData="operationExternalData"
          :flowConfig="flowConfig"
          :bizType="bizType"
          :bizNameKey="bizNameKey"
          :recycleBinConfig="recycleBinConfig"
          @refresh="refresh"
          :flowStatusTab="status"
          :statusKey="statusKey"
          :other="other"
        >
        </table-flow-btn-new>
      </template>
    </table-wrapper>
  </template>
</hmd-list-page>
